import { render, staticRenderFns } from "./lonely.vue?vue&type=template&id=3e2af8fa&scoped=true&"
import script from "./lonely.vue?vue&type=script&lang=js&"
export * from "./lonely.vue?vue&type=script&lang=js&"
import style0 from "./lonely.vue?vue&type=style&index=0&id=3e2af8fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2af8fa",
  null
  
)

export default component.exports